














import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, generalDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { OsdConfig } from '@/types/api'

// FIXME: Validator before delete (VideoWall + Matrix + Preset)

export default mixins(generalDialogMixin).extend({
  data (): {
    osdid: number,
  } {
    return {
      osdid: -1
    }
  },
  computed: {
    osd (): OsdConfig | null {
      return this.$state.device.osd.list.find(x => x.id === this.osdid) || null
    }
  },
  methods: {
    async apply () {
      if (!this.osd) { console.error('[To Developer] Impossible.'); return }
      const ok = await easyapi.deleteOsd(this.osd)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  mounted () {
    this.osdid = ~~this.$route.params.osdid
  }
})
